import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'react-toastify/dist/ReactToastify.css';

import { store } from './store';
import Approvals from './modules/approvals';
import ApprovalList from './modules/approvals/approval-list';
import ApprovalsInformation from './modules/approvals/approval-information';
import ApprovalsSignatoryRemarks from './modules/approvals/approval-signatory-remarks';
import Dashboard from './modules/dashboard';
import EmployeeRegistration from './modules/employee/employee-registration';
import EmployeeIExitInterview from './modules/employee/employee-exit-interview';
import EmployeeOTP from './modules/employee/employee-otp';
import EmployeeStatus from './modules/employee/employee-status';
import Hr from './modules/hr';
import HrAdd from './modules/hr/hr-add';
import HrAuditTrail from './modules/hr/hr-audit-trail';
import HrClearanceForm from './modules/hr/hr-clearance-form';
import HrExitInterview from './modules/hr/hr-exit-interview';
import HrInformation from './modules/hr/hr-information';
import HrList from './modules/hr/hr-list';
import Login from './modules/auth';
import NotFound from './modules/not-found';
import ProtectedRoute from './shared/components/ui/protected-route';
import SupervisorApproval from './modules/supervisor/supervisor-approval';
import SupervisorAcknowledgedSuccess from './modules/supervisor/supervisor-success/supervisor-acknowledged-success';
import SupervisorApprovedSuccess from './modules/supervisor/supervisor-success/supervisor-approved-success';
import SupervisorRejectedSuccess from './modules/supervisor/supervisor-success/supervisor-rejected-success';
import Services from './shared/services';
import { theme } from './theme.config';
import Employee from './modules/employee';

const App = () => {
  return (
    <>
      <CssBaseline />
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={1}
      />
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Provider store={store(Services)}>
            <Router>
              <Routes>
                <Route index element={<Login />} />

                <Route path='employee' element={<Employee />}>
                  <Route path='' element={<Navigate replace to='registration' />} />
                  <Route path='registration' element={<EmployeeRegistration />} />
                  <Route path=':slug/exit-interview' element={<EmployeeIExitInterview />} />
                  <Route path=':slug/otp' element={<EmployeeOTP />} />
                  <Route path=':slug/status' element={<EmployeeStatus />} />
                </Route>

                <Route path='supervisor' element={<Employee />}>
                  <Route path='' element={<Navigate replace to='/not-found' />} />
                  <Route path=':slug/approval/' element={<SupervisorApproval />} />
                  <Route path=':slug/success/approved' element={<SupervisorApprovedSuccess />} />
                  <Route
                    path=':slug/success/acknowledged'
                    element={<SupervisorAcknowledgedSuccess />}
                  />
                  <Route path=':slug/success/rejected' element={<SupervisorRejectedSuccess />} />
                </Route>

                <Route element={<ProtectedRoute />}>
                  <Route path='dashboard' element={<Dashboard />} />

                  <Route path='hr' element={<Hr />}>
                    <Route path='' element={<Navigate replace to='list' />} />
                    <Route path='list' element={<HrList />} />
                    <Route path='add' element={<HrAdd />} />
                    <Route path=':slug/audit-trail' element={<HrAuditTrail />} />
                    <Route path=':slug/information' element={<HrInformation />} />
                    <Route path=':slug/clearance-form' element={<HrClearanceForm />} />
                    <Route path=':slug/exit-interview' element={<HrExitInterview />} />
                  </Route>

                  <Route path='approvals' element={<Approvals />}>
                    <Route path='' element={<Navigate replace to='list' />} />
                    <Route path='list' element={<ApprovalList />} />
                    <Route path=':slug/information' element={<ApprovalsInformation />} />
                    <Route path=':slug/signatory-remarks' element={<ApprovalsSignatoryRemarks />} />
                  </Route>
                </Route>

                <Route path='not-found' element={<NotFound />} />

                <Route path='*' element={<Navigate replace to='/not-found' />} />
              </Routes>
            </Router>
          </Provider>
        </LocalizationProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
